import { IApplicationState } from '../../types/redux';

export function selectBrokerConsultantBannerAvailable(state: IApplicationState) {
  const isAgent = state.userRole === 'specialist';

  return state.config.isBrokerConsultantBannerEnabled && !isAgent;
}
